import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import MenuItem from 'material-ui/MenuItem'
import { TextField, SelectField } from 'redux-form-material-ui'
import RaisedButton from 'material-ui/RaisedButton'
import Paper from 'material-ui/Paper'
import Settings from 'material-ui/svg-icons/action/settings'
import { themeColors } from '../styles/theme'
import { required, email, zip } from '../form/validation'
import { getDistricts } from '../selectors'

const styles = {
  containerStyle: {
    padding: 10,
  },
  title: {
    color: themeColors.positive,
    textTransform: 'uppercase',
  },
  titleIcon: {
    fill: themeColors.positive,
    position: 'relative',
    top: 5,
    marginRight: 5,
  },
  buttonLeft: {
    marginLeft: 10,
  },
  buttonRight: {
    marginLeft: 'auto',
    marginRight: 10,
  },
  facebookBtn: {
    marginBottom: 10,
  },
  smallText: {
    fontSize: 12,
    color: themeColors.darkBlack,
    marginBottom: 0,
    marginTop: 0,
  },
  inputContainer: {
    height: 65,
  },
  btnContainer: {
    paddingTop: 30,
    marginBottom: 10,
    display: 'flex',
  },
}

const EditProfileForm = ({ handleSubmit, submitting, districts }) => (
  <Paper style={styles.containerStyle}>
    <div>
      <h3 style={styles.title}>
        <Settings style={styles.titleIcon} />Modifica Profilo
      </h3>
    </div>
    <form onSubmit={handleSubmit}>
      <div style={styles.inputContainer}>
        <Field
          name="firstname"
          component={TextField}
          hintText="Nome"
          floatingLabelText="Nome"
          fullWidth={true}
        />
      </div>
      <div style={styles.inputContainer}>
        <Field
          name="lastname"
          component={TextField}
          hintText="Cognome"
          floatingLabelText="Cognome"
          fullWidth={true}
        />
      </div>
      <div style={styles.inputContainer}>
        <Field
          name="email"
          type="email"
          component={TextField}
          validate={[required, email]}
          hintText="Mail"
          floatingLabelText="Mail"
          fullWidth={true}
        />
      </div>
      <div style={styles.inputContainer}>
        <Field
          name="address"
          component={TextField}
          hintText="Indirizzo"
          floatingLabelText="Indirizzo"
          fullWidth={true}
        />
      </div>
      <div style={styles.inputContainer}>
        <Field
          name="telephone"
          component={TextField}
          hintText="Telefono"
          floatingLabelText="Telefono"
          fullWidth={true}
        />
      </div>
      <div style={styles.inputContainer}>
        <Field
          name="city"
          component={TextField}
          hintText="Città"
          floatingLabelText="Città"
          fullWidth={true}
        />
      </div>
      <div style={styles.inputContainer}>
        <Field
          name="districtId"
          component={SelectField}
          hintText="Provincia"
          floatingLabelText="Provincia"
          fullWidth={true}>
          {districts.map(d => (
            <MenuItem key={d.id} value={d.id} primaryText={d.nome} />
          ))}
        </Field>
      </div>
      <div style={styles.inputContainer}>
        <Field
          name="zip"
          component={TextField}
          validate={[zip]}
          hintText="CAP"
          floatingLabelText="CAP"
          fullWidth={true}
        />
      </div>
      <div style={styles.btnContainer}>
        <RaisedButton
          disabled={submitting}
          label="Annulla"
          containerElement={<Link to="/profile" />}
          style={styles.buttonLeft}
          backgroundColor={themeColors.lightblack}
          labelColor={themeColors.white}
        />
        <RaisedButton
          disabled={submitting}
          type="submit"
          label="Salva Modifiche"
          primary={true}
          style={styles.buttonRight}
        />
      </div>
    </form>
  </Paper>
)

export default reduxForm({
  form: 'edit-profile-form',
})(
  connect(state => ({
    districts: getDistricts(state),
  }))(EditProfileForm)
)



// WEBPACK FOOTER //
// ./src/common/EditProfileForm.js